import { toast } from "react-toastify";
import fire from "../../config/fire";

const setPostsLoading = (message) => ({
  type: "SET_POSTS_LOADING",
  payload: message,
});
const setPosts = (data) => ({
  type: "SET_POSTS",
  payload: data,
});

export const getPosts = () => async (dispatch) => {
  dispatch(setPostsLoading(true));

  const posts = await fire.firestore().collection("advertisement").get();

  const allPosts = [];

  posts.forEach((post) => {
   // if (post.id !== "27g9Q1JzQmEZbQ8AxaBg") {
      allPosts.push({ post: post.data(), postId: post.id });
   // }
  });
  // console.log(allPosts)
  dispatch(setPostsLoading(false));
  dispatch(setPosts(allPosts));
};

export const checkPosition = (pos) => async(dispatch) => {
  // dispatch(setPostsLoading(true));
  const posts = await fire.firestore().collection("advertisement").get();

  const allPosts = [];

  posts.forEach((post) => {
      allPosts.push({ post: post.data(), postId: post.id });
  });

  return allPosts;
};

const addPost = (post) => ({
  type: "ADD_POST",
  payload: post,
});

export const newPost =
  (data, author, nameAuthor, setProgress, history) => (dispatch) => {
    fire
      .firestore()
      .collection("advertisement")
      .add({
        author: author,
        postText: data.posttext,
        location: data.location,
        description: data.description,
        startDate: data.startD,
        startTime: data.startT,
        endDate: data.endD,
        endTime: data.endT,
        position: Number(data.position),
        feedType: "ad",
        postMedia: [],
        createdAt: Date.now()
        // updatedAt: Date.now(),
        // image: null,
        
        // likes: 0,
        // comments: [],
        // postedBy: nameAuthor,
      })
      .then((doc) => {
        const fileUpload = fire
          .storage()
          .ref(`${doc.id}`)
          .put(data.image);

        fileUpload.on(
          "state_changed",
          (snapshot) => {
            const progress =
              Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // setProgress(progress);
          },
          (error) => {
            return toast.error(error.message);
          },
          () => {
            fileUpload.snapshot.ref.getDownloadURL().then((downloadURL) => {
              fire
                .firestore()
                .collection("advertisement")
                .doc(doc.id)
                .update({
                  postMedia: [{mime: "image",url: downloadURL, thumbnailURL: downloadURL}],
                  id: doc.id
                })
                .then(async (post) => {
                  const docum = await doc.get();
                  const docData = docum.data();
                  docData.image = downloadURL;
                  dispatch(addPost({ data: docData, postId: doc.id }));
                  dispatch(getPosts())
                  .then((res) => {
                    toast.success("Ad created successfuly!")
                    history.push("/admin/dashboard/posts")})
                });
            });
          }
        );
      });
  };

const addComment = (data) => ({
  type: "ADD_COMMENT",
  payload: data,
});

export const doComment = (id, comments, data) => (dispatch) => {
  fire
    .firestore()
    .collection("posts")
    .doc(id)
    .update({ comments: [...comments, data], updatedAt: Date.now() })
    .then(async () => {
      dispatch(addComment({ id, comment: data }));
    });
};

const addReply = (data) => ({
  type: "ADD_REPLY",
  payload: data,
});
export const doReply = (i, postId, comments, reply) => (dispatch) => {
  // console.log(id, comments, name, email, reply);
  const currentComment = comments.find((comment, id) => i === id);
  currentComment.replies = [...currentComment.replies, reply];
  const updatedComments = comments.map((comment, id) =>
    id === i ? currentComment : comment
  );
  fire
    .firestore()
    .collection("posts")
    .doc(postId)
    .update({ comments: updatedComments, updatedAt: Date.now() })
    .then(async () => {
      dispatch(addReply({ id: i, postId, updatedComments }));
    });
};

const removeComment = (data) => ({
  type: "DELETE_COMMENT",
  payload: data,
});

export const deleteComment = (id, postId, comments) => (dispatch) => {
  const filteredComments = comments.filter((comment, i) => i !== id);
  fire
    .firestore()
    .collection("posts")
    .doc(postId)
    .update({
      comments: filteredComments,
      updatedAt: Date.now(),
    })
    .then(() => {
      dispatch(removeComment({ filteredComments, postId }));
    });
};

const deletePost = (postId) => ({
  type: "DELETE_POST",
  payload: postId,
});

export const postDel = (postId) => (dispatch) => {
  fire
    .storage()
    .ref(`${postId}`)
    .delete()
    .then(() => {
      fire
        .firestore()
        .collection("advertisement")
        .doc(postId)
        .delete()
        .then(() => {
          dispatch(deletePost(postId));
          toast.success("Ad deleted successfully!"); 
        });
    });
};

const updatePost = (data) => ({
  type: "UPDATE_POST",
  payload: data,
});

export const postUpdate = (postId, data, history) => (dispatch) => {
  fire
    .firestore()
    .collection("advertisement")
    .doc(postId)
    .update({
      postText: data.posttext,
      location: data.location,
      description: data.description,
      startDate: data.startD,
      startTime: data.startT,
      endDate: data.endD,
      endTime: data.endT,
      position: data.position,
    })
    .then(() => {
      dispatch(updatePost({ postId, data }))
      toast.success("Ad Updated Successfully!");
      history.push("/admin/dashboard/posts");
    })
};
